import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from 'app/core/services/common.service';

@Component({
  selector: 'dialog-pass-confirm',
  templateUrl: './dialog-pass-confirm.component.html',
  styleUrls: ['./dialog-pass-confirm.component.scss']
})
export class DialogPassConfirmComponent implements OnInit {
  isLoading: boolean = false;
  passForm: FormGroup;
  type: any[] = [];
  msg: any = '';
  hidePassword: boolean = true;

  constructor(public dialogRef: MatDialogRef<DialogPassConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, private commonService: CommonService, private route: Router) {
    this.passForm = this.fb.group({
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  async save() {
    this.isLoading = true;
    const rawPassword = this.passForm.value.password;
    try {
      this.commonService.verifyPassword(rawPassword).subscribe({
        next: res => {
          if (res) {
            const storageKey = this.data?.storageKey || 'isPassConfirm';
            const navigateTo = this.data?.navigateTo || 'employee-management';
            localStorage.setItem(storageKey, 'true');
            this.route.navigate([navigateTo]);
            this.dialogRef.close();
            this.isLoading = false;
          } else {
            this.msg = 'Incorrect password. Please try again.';
            this.isLoading = false;
          }
        },
        error: err => {
          console.log(err);
          this.isLoading = false;
        }
      });
    } catch (error) {
      console.error('Hashing failed:', error);
      this.isLoading = false;
    }
  }

  private async hashSHA512(password: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }
}
